module.exports = __webpack_public_path__ + "static/media/myContentGreyIcon.a18893f6.svg";